import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

interface PostImagesProps {
  imageUrls: string[];
}

export function PostImages({ imageUrls }: PostImagesProps) {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  if (!imageUrls || imageUrls.length === 0) return null;

  return (
    <>
      <div className={`grid gap-1 rounded-lg overflow-hidden ${
        imageUrls.length === 1 ? 'grid-cols-1' : 
        imageUrls.length === 2 ? 'grid-cols-2' : 
        imageUrls.length === 3 ? 'grid-cols-2' : 'grid-cols-2'
      }`}>
        {imageUrls.map((url, i) => (
          <button
            key={i}
            type="button"
            onClick={() => setSelectedImage(url)}
            className={`overflow-hidden ${
              imageUrls.length === 3 && i === 0 ? 'col-span-2' : ''
            }`}
          >
            <img
              src={url}
              alt={`Post image ${i + 1}`}
            className={`w-full hover:scale-105 transition-transform ${
                imageUrls.length === 1 ? 'object-contain max-h-[600px]' : 'h-40 object-cover'
              }`}
              loading="lazy"
            />
          </button>
        ))}
      </div>

      <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
        <DialogContent className="max-w-3xl p-0 overflow-hidden">
          {selectedImage && (
            <img src={selectedImage} alt="Full size" className="w-full h-auto" />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
